

(function () {
    'use strict';
 
    angular
        .module('app')
        .filter('stripHtml', stripHtml);

function stripHtml($sce){
    return function(msg) { 

        //return msg;
        msg = msg.trim();
        msg = msg.replace(/(<p[^>]+?>|<p>|<\/p>)/g, "")
        
        return msg;
        

    };
}
})();
